import { render, staticRenderFns } from "./contentForm.vue?vue&type=template&id=48aa8d74&"
import script from "./contentForm.vue?vue&type=script&lang=ts&"
export * from "./contentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports